

import React, { Component, Fragment } from 'react';
import { postData } from '../../../../helpers/request';
import url from '../../../../helpers/url';
import {getYearsArray} from '../../../../helpers/functions';

import FilterMultiSelect from '../../../widgets/FilterMultiSelect';
import LoadingButton from '../../../widgets/LoadingButton';
import { Dialog } from '@blueprintjs/core';

class ReconciliationModal extends Component {
    constructor(props) {
        super(props);
        this.emptyForm = {
            recipient_ids: []
        };
        this.state = {
            showModal: false,
            form: this.emptyForm,
        };
        this.progress_years = [];
        this.years = getYearsArray();
    }
    componentDidMount() {
        window.addEventListener('open-add-reconciliation-modal', this.openModal);
    }
    componentWillUnmount() {
        window.removeEventListener('open-add-reconciliation-modal', this.openModal);
    }
    openModal = event => {
        const { detail } = event;
        this.setState({
            showModal: true,
            form: detail ? detail : {...this.emptyForm}
        });
    }
    closeModal = () => {
        this.setState({ showModal: false });
    }
    onChangeHandler = ({ text, value }) => {
        const { form } = this.state;
        form[value] = text;
        this.setState({ form });
    }
    onKeyDown = event => {
        const evt = event || window.event;
        var key = evt.keyCode || evt.which;
        if (key === 13) {
            this.reconcile();
        }
    }
    reconcile = async () => {
        let recipientIdsString = '';
        let progressYearsString = '';
        this.state.form.recipient_ids.forEach((id, i) => {
            recipientIdsString += `recipient_ids=${id}&`
        });

        this.progress_years.forEach(id => {
            progressYearsString += `progress_years=${id}&`
        });
        this.setState({ isLoading: true });
        const { success, data } = await postData({
            url: `${url.reconcile}?${recipientIdsString}${progressYearsString}`,
            options: {
                isBinary: true
            }
        })
        this.setState({ isLoading: false });
        if (success) {
            data.blob().then(content => {
                const blob = new Blob([content], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                var a = document.createElement("a");
                a.href = URL.createObjectURL(blob);
                a.download = this.progress_years.join('_') + '_reconciliation';
                a.click();
            })
        }
        this.closeModal();
    }
    onYearChange = (progress_years) => {
        this.progress_years = progress_years;
    }
    render() {
        const { showModal } = this.state;
        const yearsObject = this.years.map(year => ({ name: year, id: year }));
        return (
            <Dialog icon='merge-columns'
                style={{ width: '750px'}}
                isOpen={showModal}
                onClose={() => this.closeModal()}
                title="Reconciliation">
                { showModal ?
                    <Fragment>
                        <div className="pt-dialog-body">
                            <div className="flex-row">
                                <div className="flex-column">
                                    <FilterMultiSelect
                                        items={yearsObject}
                                        popoverProps={{ usePortal: false }}
                                        id="id"
                                        text="name"
                                        placeholder="Select years"
                                        onItemChange={this.onYearChange} />
                                </div>
                            </div>
                        </div>
                        <div className="pt-dialog-footer">
                            <div className="pt-dialog-footer-actions">
                                <LoadingButton className="pt-button pt-fill pt-intent-primary pt-large" text="Reconcile" onClick={this.reconcile} isLoading={this.state.isLoading} />
                            </div>
                        </div>
                    </Fragment> : null
                }
            </Dialog>
        );
    }
}

export default ReconciliationModal;
                          


// WEBPACK FOOTER //
// ./src/components/main/reconciliation/modals/ReconciliationModal.jsx